import { Bell, Link2, Monitor } from 'lucide-react'
import { LandingSection } from './LandingSection'

const steps = [
  {
    icon: Link2,
    title: 'Add your URLs',
    description:
      'Paste websites, APIs, SSL certificates, or domain names to watch. Set check options and escalation policies.',
  },
  {
    icon: Monitor,
    title: 'See status at a glance',
    description:
      'Your dashboard shows which monitors are up, down, or degraded—with uptime percentages and recent check history.',
  },
  {
    icon: Bell,
    title: 'Get Slack or email alerts',
    description:
      'When a check fails, your team hears about it via Slack or email. Escalation policies recheck failures and escalate when needed.',
  },
]

export function LandingHowItWorks() {
  return (
    <LandingSection
      id="how-it-works"
      title="How Pingscalate monitors your sites"
      subtitle="Set up in minutes. No agents to install—just URLs, a schedule, and your alert channels."
    >
      <ol className="grid gap-6 sm:grid-cols-3">
        {steps.map((step, index) => (
          <li
            key={step.title}
            className="rounded-xl border border-border bg-surface/40 p-6 backdrop-blur-sm"
          >
            <span className="text-xs font-medium uppercase tracking-wide text-accent">
              Step {index + 1}
            </span>
            <div className="mt-4 flex h-10 w-10 items-center justify-center rounded-lg bg-accent/15">
              <step.icon className="h-5 w-5 text-accent" aria-hidden />
            </div>
            <h3 className="mt-4 text-lg font-semibold text-text-primary">{step.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-text-secondary">{step.description}</p>
          </li>
        ))}
      </ol>
    </LandingSection>
  )
}
